const maps = {
  default: {
    'tile_source': 'https://bb209a101d41d7029d4e-93330d88a2f4bfa442606fd6e2955d9a.ssl.cf5.rackcdn.com/perennial-garden/test6/{z}/{x}/{y}.png',
    'map_extent': [-73.883337, 40.861474, -73.879023, 40.866053],
    'view_extent': [-73.88042568132778, 40.86337135266669, -73.88210291422008, 40.86424321795349],
    'center': [-73.88110455774351, 40.863663913246825],
    'include_osm': false,
    'debug': false,
    'min_zoom': 19,
    'max_zoom': 21,
    'start_zoom': 21,
    'click_latlon': true
  }
}

export default maps
